var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ElSwitch } from "element-plus";
import { computed, toValue } from "vue";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { useBuiltComponentVariable } from "src/shared/store/component-built/composables/useBuiltComponentVariable";
import { useDestructuredEvaluatableValue } from "src/shared/evaluatable";
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import { useComponentType } from "src/shared/store/component-type/composables/useComponentType";
const tooltipMessageWhenReadonly = "This setting is readonly";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableToolbarEnabledSwitch',
    props: {
        componentMutableKey: {}
    },
    setup(__props) {
        const props = __props;
        const { componentVariableMutable } = useComponentVariableMutable(() => props.componentMutableKey, "enabled");
        const { builtComponentVariable } = useBuiltComponentVariable(() => { var _a; return (_a = componentVariableMutable.value) === null || _a === void 0 ? void 0 : _a.getComponentId(); }, "enabled");
        const { builtComponent } = useBuiltComponent(() => { var _a; return (_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.context.componentId; });
        const isSourceLocal = computed(() => {
            var _a;
            return ((_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.source) === "LOCAL";
        });
        const defaultValue = computed(() => {
            var _a;
            return (_a = componentVariableMutable.value) === null || _a === void 0 ? void 0 : _a.getValue("default");
        });
        const { isProvided: isDefaultValueProvided } = useDestructuredEvaluatableValue(defaultValue);
        const { componentType } = useComponentType(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.type; });
        const isEditable = computed(() => {
            return (builtComponentVariable.value &&
                isSourceLocal.value &&
                isDefaultValueProvided);
        });
        const tooltipMessageWhenEnabledAndEditable = computed(() => {
            if (componentType.value) {
                return `Maintain settings but disable all functionality of this ${componentType.value.getDisplayName().toLowerCase()}`;
            }
            return `Maintain settings but disable all functionality`;
        });
        const tooltipMessageWhenDisabledAndEditable = computed(() => {
            if (componentType.value) {
                return `Enable all functionality of this ${componentType.value.getDisplayName().toLowerCase()}`;
            }
            return `Enable all functionality`;
        });
        const tooltipMessage = computed(() => {
            if (!isEditable.value) {
                return tooltipMessageWhenReadonly;
            }
            return isEnabled.value
                ? tooltipMessageWhenEnabledAndEditable.value
                : tooltipMessageWhenDisabledAndEditable.value;
        });
        const isEnabled = computed({
            get() {
                const componentVariableMutableValue = toValue(componentVariableMutable);
                if (!componentVariableMutableValue) {
                    return false;
                }
                const defaultValue = componentVariableMutableValue.getValue("default");
                return Boolean(defaultValue);
            },
            set: (newValue) => __awaiter(this, void 0, void 0, function* () {
                const componentVariableMutableValue = toValue(componentVariableMutable);
                if (!componentVariableMutableValue) {
                    return;
                }
                componentVariableMutableValue.setValue("default", newValue);
            }),
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Tooltip, { message: tooltipMessage.value }, {
                default: _withCtx(() => [
                    _createVNode(_unref(ElSwitch), {
                        modelValue: isEnabled.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isEnabled).value = $event)),
                        disabled: !isEditable.value
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["message"]));
        };
    }
});
